import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-polyglot'
import { connect } from 'react-redux'
import { List } from 'immutable'
import Mousetrap from 'mousetrap'
import Fuse from 'fuse.js'

import history from 'configureHistory'
import { articleActions } from 'features/articles'

import { PageOverlay, Button, Icon, Text } from 'components'
import { getShortcutString } from 'components/Shortcut'

import FusePicker from './Results'

import './search.scss'

class Search extends Component {
	constructor(props) {
		super(props)

		this.searchInput = React.createRef()
		// this.fuse = new Fuse(props.items, props.fuseOptions)

		this.timer = null

		this.state = {
			isOpen: false,
			selectedIndex: 0,
			items: [],
			value: '',
		}
	}

	componentDidMount() {
		Mousetrap(document.querySelector('body')).bind(
			getShortcutString('search'),
			this.toggle
		)
	}

	componentWillUnmount() {
		Mousetrap(document.querySelector('body')).unbind(
			getShortcutString('search'),
			this.toggle
		)
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { articles } = this.props

		let articlesMap = []

		// Whenever articles have changed
		if (JSON.stringify(nextProps.articles) !== JSON.stringify(articles)) {
			// If there are articles
			if (nextProps.articles.size) {
				// if (nextProps.articles.size && nextProps.articles.toJSON()[0].content) {
				articlesMap = nextProps.articles.toJSON().map(article => {
					const content = article.content.length
						? article.content
						: ''

					const transformedArticle = {
						id: article._id,
						title: article.title,
						content,
					}

					return transformedArticle
				})

				this.fuse = new Fuse(articlesMap, this.props.fuseOptions)
			}
		}
	}

	jumpTo = id => {
		history.push({
			pathname: id,
			state: {
				ref: 'search',
				keyword: this.state.value,
			},
		})
	}

	_selectIndex = selectedIndex => {
		this.props.onChangeHighlighted(this.state.items[selectedIndex])
		this.setState({ selectedIndex })
	}

	_moveUp = () => {
		if (this.state.selectedIndex > 0) {
			this._selectIndex(this.state.selectedIndex - 1)
			return
		}

		if (!this.props.cycleToTop) {
			return
		}

		this._selectIndex(this.state.items.length - 1)
	}

	_moveDown = () => {
		const itemsLength = this.state.items.length - 1

		if (this.state.selectedIndex < itemsLength) {
			this._selectIndex(this.state.selectedIndex + 1)
			return
		}

		if (!this.props.cycleToTop) {
			return
		}

		this._selectIndex(0)
	}

	_onKeyDown = event => {
		switch (event.key) {
			case 'ArrowUp':
				this._moveUp()
				event.preventDefault()
				break

			case 'ArrowDown':
				this._moveDown()
				event.preventDefault()
				break

			case 'Tab':
				if (event.shiftKey) {
					this._moveUp()
				} else {
					this._moveDown()
				}
				event.preventDefault()
				break

			case 'Enter':
				const item = this.state.items[this.state.selectedIndex]
				if (!item) {
					return
				}
				this.toggle()
				this.jumpTo(item.id)
				break

			case 'Escape':
				this.toggle()
				break

			default:
		}
	}

	_onInputChange = event => {
		const { value } = event.target

		if (this.fuse && value.length > 0) {
			clearTimeout(this.timer)

			this.timer = setTimeout(() => {
				const items = this.fuse.search(value)

				this.setState({
					items,
					selectedIndex: 0,
					value,
				})
			}, 50)
		} else {
			this.setState({
				items: [],
				selectedIndex: 0,
				value,
			})
		}
	}

	// First time loading, fetch all articles and titles
	// instead of using redux state
	replacer = match =>
		`<span class="o-search-results__highlight">${match}</span>`

	highlight = (text, search, truncate = true) => {
		// Only highlighting first word, maybe do both, first and everything
		const searchFor =
			search.indexOf(' ') > 0
				? search.substr(0, search.indexOf(' '))
				: search
		const re = new RegExp(searchFor, 'gi')
		const length = 140
		let t = text

		if (truncate) {
			if (t.toLowerCase().indexOf(searchFor.toLowerCase()) - 20 > 0) {
				t = `...${t.substring(
					t.toLowerCase().indexOf(searchFor.toLowerCase()) - 20,
					t.toLowerCase().indexOf(searchFor.toLowerCase()) +
						(length - 20)
				)}...`
			} else {
				t = `${t.substring(0, length)}...`
			}
		}

		return t.replace(re, this.replacer)
	}

	toggle = () => {
		const { isOpen } = this.state

		if (isOpen === false) {
			const { getArticlesIndex } = this.props

			getArticlesIndex()
		}

		this.setState({ isOpen: !isOpen, selectedIndex: 0, items: [] })
	}

	renderSearch = () => {
		const { isOpen } = this.state
		const { t } = this.props

		return (
			<FusePicker
				isOpen={isOpen}
				onClose={() => this.toggle()}
				onChange={choice => {
					this.toggle()
					this.jumpTo(choice.id)
				}}
				renderItem={item => {
					const searchValue = this.searchInput.current
						? this.searchInput.current.value
						: ''
					const title =
						item.title && item.title.length
							? item.title
							: t('no_title')

					return (
						<div>
							<h4
								dangerouslySetInnerHTML={{
									__html: this.highlight(
										title,
										searchValue,
										false
									),
								}}
							/>
							<Text>
								<div
									dangerouslySetInnerHTML={{
										__html: this.highlight(
											item.content,
											searchValue
										),
									}}
								/>
							</Text>
						</div>
					)
				}}
				fuseOptions={{
					shouldSort: true,
					threshold: 0.4,
					location: 0,
					tokenize: true,
					distance: 1000,
					maxPatternLength: 20,
					minMatchCharLength: 3,
					keys: ['title', 'content'],
				}}
				items={this.state.items}
				_selectIndex={this._selectIndex}
				selectedIndex={this.state.selectedIndex}
				searchInput={this.searchInput}
			/>
		)
	}

	render() {
		const { isOpen } = this.state
		const { t } = this.props

		return (
			<>
				<Button
					icon={<Icon name="search" />}
					onClick={() => this.toggle()}
				/>

				<PageOverlay
					visible={isOpen}
					location={location}
					onClose={() => this.toggle()}
					header={
						<div className="o-search-input">
							<input
								type="search"
								className="o-search-input__field"
								autoFocus
								placeholder={t('search_placeholder')}
								onKeyDown={this._onKeyDown}
								onChange={this._onInputChange}
								ref={this.searchInput}
							/>
						</div>
					}
				>
					{this.renderSearch()}
				</PageOverlay>
			</>
		)
	}
}

Search.propTypes = {
	articles: PropTypes.instanceOf(List).isRequired,
	getArticlesIndex: PropTypes.func.isRequired,
}

Search.defaultProps = {
	cycleToTop: true,
	fuseOptions: {
		shouldSort: true,
		threshold: 0.4,
		location: 0,
		tokenize: true,
		distance: 1000,
		maxPatternLength: 20,
		minMatchCharLength: 3,
		keys: ['title', 'content'],
	},
	onChangeHighlighted(item) {},
	onChange(item) {},
	onClose() {},
}

const mapStateToProps = state => ({
	articles: state.articles.listIndex,
})

const mapDispatchToProps = {
	getArticlesIndex: articleActions.getArticlesIndexRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(Search))
